import getActions from './getActions';
import useCallForm from '@evercall/call-form/application/useCallForm';

export default () => {
  const { state, ...callFormActions } = useCallForm();
  return {
    state,
    ...getActions({ ...callFormActions }),
  };
};
